var _desc, _defs, _rect, _text;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoWithWritingWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 460,
    height: 108,
    viewBox: "0 0 460 108",
    role: "img",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, "Fetivo.de") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", {
    id: "desc"
  }, "Fetivo wordmark with pink, violet and blue gradient lettering.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "fetivoGradient",
    x1: 0,
    y1: 12,
    x2: 440,
    y2: 92,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff4fb7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#d566ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#86b7ff"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "softGlow",
    x: "-8%",
    y: "-24%",
    width: "116%",
    height: "148%",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 0,
    dy: 5,
    stdDeviation: 5,
    floodColor: "#6513a8",
    floodOpacity: 0.28
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 460,
    height: 108,
    fill: "none"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 4,
    y: 76,
    fill: "url(#fetivoGradient)",
    filter: "url(#softGlow)",
    fontFamily: "Nunito, Arial, sans-serif",
    fontSize: 68,
    fontWeight: 900,
    letterSpacing: -1
  }, "\n    Fetivo.de\n  ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoWithWritingWhite);
export default __webpack_public_path__ + "static/media/logo-with-writing-white.7d85644631c4448168309c0face8eecf.svg";
export { ForwardRef as ReactComponent };